let methodGroups = [
  // {
  //   title: '快捷支付',
  //   items: [
  // { id: 'motoPay', label: '支付宝信用卡', bankId: 'motoPay', payType: 'ALIP' },
  // { id: 'bankPay', label: '支付宝借记卡', bankId: 'bankPay', payType: 'ALIP' },
  // { id: 'EPOS-NET', label: '易宝快捷支付  信用卡', bankId: 'EPOS-NET', payType: 'YEEPAY' }
  //   ]
  // },
  {
    title: '网银支付',
    items: [
      { id: 'ICBC', label: '易生  直连  工商银行', bankId: 'ICBC', payType: 'ECARD' },
      { id: 'CCB', label: '易生  直连  建设银行', bankId: 'CCB', payType: 'ECARD' },
      { id: 'BOC', label: '易生  直连  中国银行', bankId: 'BOC', payType: 'ECARD' },
      { id: 'CITIC', label: '易生  直连  中信银行', bankId: 'CITIC', payType: 'ECARD' },
      { id: 'ABC', label: '易生  直连  农业银行', bankId: 'ABC', payType: 'ECARD' },
      { id: 'CMB', label: '易生  直连  招商银行', bankId: 'CMB', payType: 'ECARD' },
      { id: 'PSBC', label: '易生  直连  邮政银行', bankId: 'PSBC', payType: 'ECARD' },
      { id: 'HSBC', label: '支付宝  直连  交通银行', bankId: 'HSBC', payType: 'ECARD' },
      { id: 'SDB', label: '易生  直连  平安银行', bankId: 'SDB', payType: 'ECARD' },
      { id: 'CMBC', label: '易生  直连  民生银行', bankId: 'CMBC', payType: 'ECARD' },
      { id: 'CEB', label: '支付宝  直连  光大银行', bankId: 'CEB', payType: 'ECARD' },
      { id: 'CIB', label: '支付宝  直连  兴业银行', bankId: 'CIB', payType: 'ECARD' },
      { id: 'GDB', label: '支付宝  直连  广发银行', bankId: 'GDB', payType: 'ECARD' },
      { id: 'SPDB', label: ' 易生  直连  上海浦东发展银行', bankId: 'SPDB', payType: 'ECARD' },
      { id: 'SHBANK', label: '易生  直连  上海银行', bankId: 'SHBANK', payType: 'ECARD' },
      { id: 'FDB', label: '支付宝  直连  富滇银行', bankId: 'FDBK', payType: 'ECARD' }
    ]
  },
  {
    title: '支付平台',
    items: [
      { id: 'alipYE', label: '支付宝平台', bankId: 'alipYE', payType: 'ALIP' },
      { id: 'WX', label: '微信支付平台', bankId: 'WX', payType: 'WECHAT' },
      // { id: 'CCB_PAY', label: '建行支付平台', bankId: '', payType: 'CCB_PAY' },
      { id: 'YEEPAY', label: '易宝平台', bankId: '', payType: 'YEEPAY' },
      { id: 'DIRECTPAY', label: '易生平台', bankId: 'DIRECTPAY', payType: 'ECARD' }
    ]
  },
  {
    title: '其他支付方式',
    items: [
      // { id: 'alipYFK', label: '支付宝祥鹏商旅卡', bankId: 'alipYFK', payType: 'ALIP' },
      // { id: 'YEEPAYCREDIT', label: '易宝信用支付', bankId: 'YEEPAYCREDIT', payType: 'YEEPAY' },
      // { id: 'ICBC-BIND', label: '易宝工行航旅支付', bankId: 'ICBC-BIND', payType: 'YEEPAY' },
      { id: 'VR_PAY', label: '虚拟账户支付', bankId: 'VR_PAY', payType: 'VR_PAY' }
    ]
  }
]

export default methodGroups
